module.exports = __webpack_public_path__ + "img/verified.9ac32693.svg";